import { render } from "./StartupResourcesView.vue?vue&type=template&id=15c3bc26&ts=true"
import script from "./StartupResourcesView.vue?vue&type=script&lang=ts"
export * from "./StartupResourcesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__